import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 100% !important;

  &.web,
  &.mobile {
    display: none;
  }

  .timer-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    height: 3.75rem;
    padding: 0;
    background-color: var(--primary_color);
  }

  .timer-content > div {
    display: flex;
    align-items: center;
  }

  .timer-selo {
    height: 3.75rem;
    width: 3.75rem;
  }

  .timer-countdown {
    display: flex;
    flex-direction: row;
    font-weight: bold;

    > div {
      display: flex;
      flex-direction: column;
    }

    span,
    strong {
      width: 2.7rem;
      text-align: center;
    }

    span {
      font-size: 0.6rem;
    }

    strong {
      font-size: 1.3rem;
    }

    .timer-separator strong {
      width: 0.2rem;
    }
  }

  .timer-text {
    font-weight: 700;
    text-transform: uppercase;
    color: var(--white);
    margin: 0 1.87rem 0 1.25rem;
    letter-spacing: 0.1rem;
    font-size: 1.2rem;
    width: max-content;
  }

  @media (max-width: 1200px) {
    .timer-text {
      font-size: 0.9rem;
    }
  }

  @media (max-width: 768px) {
    .timer-content > div {
      display: grid;
      grid-template-areas:
        'item1 item1'
        'item2 item3';
    }

    .timer-selo {
      margin-right: 1rem;
      width: 100%;
      max-width: 3.75rem;
      height: 100%;
      max-height: 3.75rem;
    }

    .timer-text {
      margin: 0;
    }

    .timer-text.item1 {
      grid-area: item1;
      min-height: 0;
      min-width: 0;
    }

    .timer-text.item2 {
      grid-area: item2;
    }

    .timer-box {
      grid-area: item3;
      margin-left: 0.5rem;
    }
  }

  @media (max-width: 520px) {
    .timer-text {
      font-size: 0.8rem;
    }
  }

  @media (max-width: 400px) {
    .timer-text {
      font-size: 0.7rem;
    }

    .timer-countdown {
      span,
      strong {
        width: 2.4rem;
      }

      span {
        font-size: 0.5rem;
      }

      strong {
        font-size: 1.1rem;
      }
    }
  }

  @media (max-width: 360px) {
    .timer-selo {
      margin: 0;
      padding-right: 0.5rem;
    }

    .timer-text {
      font-size: 0.6rem;
    }
  }
`;
